import { useState } from "react";

export const useSleep = () => {
  const [isPending, setIsPending] = useState(false);

  const sleep = async (ms: number) => {
    setIsPending(true);
    await new Promise((resolve) => setTimeout(resolve, ms));
    setIsPending(false);
  };

  return {
    isPending,
    sleep,
  };
};
